import React, { forwardRef, RefObject } from 'react';
import { styled } from 'styled-components';

import { ButtonWrapper, LinkWrapper } from './styles';
import { isTextLinkButton, TextLinkProps } from './types';

const TextLink = forwardRef<HTMLButtonElement | HTMLAnchorElement, TextLinkProps>((props, ref) => {
  if (isTextLinkButton(props)) {
    return <ButtonWrapper type="button" ref={ref as RefObject<HTMLButtonElement>} {...props} />;
  }

  const { isExternal, isSmall, ...linkProps } = props;

  const linkButtonProps = {
    ...linkProps,
    ...(isExternal && {
      target: '_blank',
      rel: 'noreferrer noopener',
    }),
  };

  return <LinkWrapper ref={ref as RefObject<HTMLAnchorElement>} isSmall={!!isSmall} {...linkButtonProps} />;
});
TextLink.displayName = 'TextLink';
export default styled(TextLink)``;
